import { createEntityReducer } from "@selas/state-management";
import Endpoint from "../../services/api/endpoint";
import { IProjectNote } from "../../utils/types/models";

export default createEntityReducer<IProjectNote>(Endpoint.ProjectNotes, Endpoint.ProjectNotesList);
